import React from 'react';
import CaseMenuMobile from './CaseMenuMobile';
import {Icon} from 'antd';
import './CaseTitleMobile.less';

function CaseTitleMobile({children, menu, visible, onVisible}) {
  return (
    <div className='CaseTitleMobile'>
      <h1 onClick={onVisible}>
        <span>{children}</span>
        <Icon type={visible ? 'up' : 'down'}/>
      </h1>
      {visible ? <CaseMenuMobile menu={menu}/> : null}
    </div>
  );
}

class CaseTitleMobileContainer extends React.Component {
  state = {visible: false};

  render() {
    const props = {
      menu: this.props.menu,
      visible: this.state.visible,
      onVisible: () => this.setState({visible: !this.state.visible})
    };
    return <CaseTitleMobile {...props}>{this.props.children}</CaseTitleMobile>;
  }
}

export default CaseTitleMobileContainer;


// WEBPACK FOOTER //
// ./src/routes/Case/CaseTitleMobile.js